export default "__VITE_ASSET__C86_tyoz__"